module.exports = __webpack_public_path__ + "assets/img/modal-avatar-928a3b18.png";